import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Login from "@/components/organisms/Login.vue"
import { useHead } from "@vueuse/head"


export default /*#__PURE__*/_defineComponent({
  __name: 'Loginpage',
  setup(__props) {

useHead({ title: "Comissão Revenda - Login" })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Login))
}
}

})